export const cookieOptions = [
  {
    title: 'cookies.cookie.essential.title',
    id: 'essential',
    description: 'cookies.cookie.essential.description',
    isAllow: true,
  },
  {
    title: 'cookies.cookie.preferences.title',
    id: 'preference',
    description: 'cookies.cookie.preferences.description',
    isAllow: false,
  },
  {
    title: 'cookies.cookie.analytics.title',
    id: 'analytics',
    description: 'cookies.cookie.analytics.description',
    isAllow: false,
  },
  {
    title: 'cookies.cookie.advertising.title',
    id: 'advertising',
    description: 'cookies.cookie.advertising.description',
    isAllow: false,
  },
];
